package one.healthium.insights.data.mapper

import one.healthium.db.SavedContentEntity
import one.healthium.db.dao.SavedContentType
import one.healthium.insights.domain.content.ContentOptions
import one.healthium.insights.domain.models.ContentPreviewModel
import one.healthium.insights.domain.models.SavedContentModel
import one.healthium.insights.domain.models.SavedContentOptions
import kotlin.time.Clock

class SavedContentMapper {
    fun entityToModel(entity: SavedContentEntity): SavedContentModel? {
        val contentOptions = entity.contentType.toContentOptions(entity.contentId) ?: return null

        return SavedContentModel(
            id = entity.id,
            contentOptions = contentOptions,
            content = ContentPreviewModel(
                title = entity.title,
                description = entity.description,
                thumbUrl = entity.thumbUrl,
            ),
        )
    }

    fun optionsToEntity(
        options: SavedContentOptions,
        type: SavedContentType,
    ): SavedContentEntity {
        return SavedContentEntity(
            id = options.contentOptions.toStorageId(type),
            contentId = options.contentOptions.id,
            contentType = options.contentOptions.toStorageType(),
            title = options.contentPreview.title,
            description = options.contentPreview.description,
            thumbUrl = options.contentPreview.thumbUrl,
            saveType = type.value,
            savedAt = Clock.System.now().toEpochMilliseconds(),
        )
    }
}

private fun ContentOptions.toStorageId(type: SavedContentType): String {
    return when (this) {
        is ContentOptions.Category -> "category_${id}_${type.value}"
        is ContentOptions.Insight -> "insight_${id}_${type.value}"
        is ContentOptions.MealPlan -> "meal_plan_${id}_${type.value}"
        is ContentOptions.Recipe -> "recipe_${id}_${type.value}"
        is ContentOptions.Workout -> "workout_${id}_${type.value}"
    }
}

private fun ContentOptions.toStorageType(): String {
    return when (this) {
        is ContentOptions.Category -> "category"
        is ContentOptions.Insight -> "insight"
        is ContentOptions.MealPlan -> "meal_plan"
        is ContentOptions.Recipe -> "recipe"
        is ContentOptions.Workout -> "workout"
    }
}

private fun String.toContentOptions(id: String): ContentOptions? {
    return when (this) {
        "category" -> ContentOptions.Category(id)
        "insight" -> ContentOptions.Insight(id)
        "meal_plan" -> ContentOptions.MealPlan(id)
        "recipe" -> ContentOptions.Recipe(id)
        "workout" -> ContentOptions.Workout(id)
        else -> null
    }
}